<template>
    <!-- <div @click="contactLogsMethod(dataObject.contact_group_id)">
        <router-link
            :to="{
                name: 'contact.board.detail',
                params: {
                    id: dataObject.board_id,
                    groupId: dataObject.contact_group_id,
                },
            }"
        >
            <div
                class="item_inner flex items-start px-3 py-4 border border-gray-200 rounded-lg mb-4 hover:bg-gray-100"
            >
                <div class="flex items-start">
                    <div class="flex items-center justify-center mr-2">
                        <template
                            v-for="(
                                contacts, contactsIndex
                            ) in dataObject.contacts"
                            :key="contactsIndex"
                        >
                            <span
                                class="flex w-8 h-8 items-center justify-center bg-slate-600 rounded-full [&:not(:first-child)]:-ml-3 text-white"
                                :class="contacts.badge"
                            >
                                <span>
                                    {{ replaceMarkTag(contacts.first_name) }}
                                </span>
                                <template v-if="contacts.last_name">
                                    <span>
                                        {{ replaceMarkTag(contacts.last_name) }}
                                    </span>
                                </template>
</span>
</template>
</div>
<div class="flex flex-col">
    <span class="text-sm font-medium mb-1" v-html="
                                getFirstNamesWithAmpersand(dataObject.contacts)
                            "></span>
    <span class="text-xs font-light text-black-900 mb-1">
        <span v-html="dataObject.name"></span>
        <span v-html="groupEmailContact(dataObject.contacts)"></span>
    </span>
    <div class="flex item-center">
        <template v-for="(user, userIndex) in dataObject.users" :key="userIndex">
                                <div>
                                    <img
                                        :src="getUserImage(user.image_path)"
                                        :alt="user.first_name"
                                        class="w-6 h-6 rounded-full mr-2"
                                    />
                                </div>
                            </template>
        <template v-for="(label, labelIndex) in dataObject.labels" :key="labelIndex">
                                <div class="mr-2">
                                    <app-label
                                        :classes="label.color"
                                        :text="label.name"
                                    ></app-label>
                                </div>
                            </template>
        <div>
            <app-label :text="
                                        'STEP ' + dataObject.steps.step_level
                                    " :isStep="true" :secondText="dataObject.steps.step_name"></app-label>
        </div>
    </div>
</div>
</div>
</div>
</router-link>
</div> -->
    <div>
        <div v-for="contact in data" class="flex gap-[77px] items-center mb-6 last-of-type:mb-0">
            <MutliContactNameIcon class="lg:min-w-[315px] md:min-w-[235px]" :data="contact.contacts" :isLarge="true"
                badgeClass="" nameText="" nameLetter="Tesss" lastNameLetter="" :search="true" />
            <!-- {{ contact.board}} -->
            <div class="flex justify-between items-center gap-[41px] w-full">
                <div class="contact-reference text-nowrap">
                    <p class="text-xs text-black-900 leading-none">{{ contact.board }} | {{ contact.type }}:
                        {{ contact.step }}
                    </p>
                </div>
                <div class="contact-users">
                    <img class="w-6 rounded-full" :alt="contact.user.userAlt" src="@/assets/images/user.png">
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import AppLabel from '@/components/AppLabel.vue';
import MutliContactNameIcon from '@/components/contacts/MutliContactNameIcon.vue';
import {
    getFirstNamesWithAmpersand,
    groupEmailContact,
    getUserImage,
    replaceMarkTag,
} from '@/composables/globals';
const emits = defineEmits(['contactLogs']);
const props = defineProps({
    dataObject: {
        type: Object,
        default: () => { },
    },
});
const data = [
    {
        board: 'vendor',
        type: 'Residential',
        step: 'New lead',
        user: {
            userImage: 'user image url',
            userAlt: 'user alt',
        },
        contacts: [
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_a",
                "email": "email@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0204 905 9884"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "name",
                "first_name": "Contact",
                "vat_number": null,
                "contacts_id": 33,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
        ]
    },
    {
        board: 'vendor',
        type: 'Residential',
        step: 'New lead',
        user: {
            userImage: 'user image url',
            userAlt: 'user alt',
        },
        contacts: [
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_m",
                "email": "test1@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0343 434 3434"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "David",
                "first_name": "Jason",
                "vat_number": null,
                "contacts_id": 33,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_d",
                "email": "test2@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0343 464 5454"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "Paulus",
                "first_name": "Amanda",
                "vat_number": null,
                "contacts_id": 34,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_o",
                "email": "test2@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0343 464 5454"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "Tom",
                "first_name": "Aton",
                "vat_number": null,
                "contacts_id": 34,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            }
        ]
    },
    {
        board: 'vendor',
        type: 'Residential',
        step: 'New lead',
        user: {
            userImage: 'user image url',
            userAlt: 'user alt',
        },
        contacts: [
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_a",
                "email": "email@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0204 905 9884"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "name",
                "first_name": "Contact",
                "vat_number": null,
                "contacts_id": 33,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
        ]
    },
    {
        board: 'vendor',
        type: 'Residential',
        step: 'New lead',
        user: {
            userImage: 'user image url',
            userAlt: 'user alt',
        },
        contacts: [
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_a",
                "email": "email@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0204 905 9884"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "name",
                "first_name": "Contact",
                "vat_number": null,
                "contacts_id": 33,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
        ]
    },
    {
        board: 'vendor',
        type: 'Residential',
        step: 'New lead',
        user: {
            userImage: 'user image url',
            userAlt: 'user alt',
        },
        contacts: [
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_m",
                "email": "test1@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0343 434 3434"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "David",
                "first_name": "Jason",
                "vat_number": null,
                "contacts_id": 33,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_d",
                "email": "test2@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0343 464 5454"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "Paulus",
                "first_name": "Amanda",
                "vat_number": null,
                "contacts_id": 34,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            },
            {
                "lat": null,
                "lng": null,
                "town": null,
                "badge": "name_icon_o",
                "email": "test2@gmail.com",
                "title": "1",
                "county": null,
                "phone1": [
                    {
                        "phone": {
                            "type": "1",
                            "code": "+44",
                            "phoneNumber": "0343 464 5454"
                        }
                    }
                ],
                "country": null,
                "photo_id": null,
                "postcode": null,
                "last_name": "Tom",
                "first_name": "Aton",
                "vat_number": null,
                "contacts_id": 34,
                "lead_source": "10",
                "company_name": null,
                "selected_data": null,
                "address_line_1": null,
                "address_line_2": null,
                "address_line_3": null,
                "company_number": null,
                "uk_bank_details": null,
                "proof_of_address": null,
                "full_bank_details": null,
                "simple_bank_details": null
            }
        ]
    },
]
const contactLogsMethod = (groupId) => {
    console.log(groupId);
    emits('contactLogs', {
        type: 'contact',
        contact_id: groupId,
        search_from: 'search',
    });
};
</script>
<style scoped></style>
